import React, { memo } from "react";
import { GoogleMap, Circle, Rectangle, Marker } from "@react-google-maps/api";
import styles from "../LocationHistory.module.css";

const LocationHistoryMap = ({ locationHistory, heading }) => {
  const hasCoords =
    locationHistory?.latitude != null && locationHistory?.longitude != null;

  return (
    <div className={styles.mapCol}>
      <div className={styles.mapHeader}>
        <h5 className={styles.mapHeaderTitle}>{heading}</h5>
        <div className={styles.legend}>
          <span className={styles.legendItem}>
            <span className={`${styles.legendDot} ${styles.legendDotAlert}`} />
            Alert
          </span>
          <span className={styles.legendItem}>
            <span className={`${styles.legendDot} ${styles.legendDotSafe}`} />
            Safe zone
          </span>
        </div>
      </div>
      <div className={styles.mapWrapper}>
        {hasCoords ? (
          <GoogleMap
            mapContainerClassName={styles.mapContainer}
            mapContainerStyle={{ width: "100%", height: "100%" }}
            zoom={17}
            center={{
              lat: locationHistory.latitude,
              lng: locationHistory.longitude,
            }}
            options={{
              mapTypeControl: false,
              draggable: true,
              scaleControl: false,
              scrollwheel: true,
              navigationControl: false,
              streetViewControl: false,
              zoomControl: true,
              fullscreenControl: true,
              clickableIcons: false,
              gestureHandling: "greedy",
            }}
          >
            <Circle
              editable={false}
              draggable={false}
              center={{
                lat: locationHistory.latitude,
                lng: locationHistory.longitude,
              }}
              radius={locationHistory?.locationAccuracy}
              options={{
                fillColor: "#dc3545fa",
                fillOpacity: 0.2,
                strokeColor: "#dc3545fa",
                strokeWeight: 1,
              }}
            />
            <Marker
              position={{
                lat: locationHistory.latitude,
                lng: locationHistory.longitude,
              }}
            />

            {locationHistory?.safeLocation?.fenceType === "RECTANGLE" ? (
              <>
                <Rectangle
                  bounds={locationHistory?.safeLocation?.geoFenceData}
                  options={{
                    fillColor: "#198754",
                    fillOpacity: 0.2,
                    strokeColor: "#198754",
                    strokeWeight: 1,
                  }}
                />
                <Marker
                  position={{
                    lat:
                      (locationHistory?.safeLocation?.geoFenceData.north +
                        locationHistory?.safeLocation?.geoFenceData.south) /
                      2,
                    lng:
                      (locationHistory?.safeLocation?.geoFenceData.east +
                        locationHistory?.safeLocation?.geoFenceData.west) /
                      2,
                  }}
                  icon="http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                />
              </>
            ) : (
              <>
                <Circle
                  editable={false}
                  draggable={false}
                  center={locationHistory?.safeLocation?.geoFenceData?.center}
                  radius={locationHistory?.safeLocation?.geoFenceData?.radius}
                  options={{
                    fillColor: "#198754",
                    fillOpacity: 0.2,
                    strokeColor: "#198754",
                    strokeWeight: 1,
                  }}
                />
                <Marker
                  position={locationHistory?.safeLocation?.geoFenceData?.center}
                  icon="http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                />
              </>
            )}
          </GoogleMap>
        ) : (
          <div className={styles.emptyState}>
            <p className={styles.emptyTitle}>No map data</p>
            <p className={styles.emptyDesc}>
              Select an alert from the list to view it on the map.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(LocationHistoryMap);
